import React, { useEffect } from "react";

export default function PrivacyPolicy() {
  useEffect(() => {
    document.title = "นโยบายความเป็นส่วนตัว - Encraft";
  }, []);

  return (
    <div className="content-container">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-9">
            <h1 className="mb-2">นโยบายความเป็นส่วนตัว (Privacy Policy)</h1>
            <p className="text-muted mb-4">
              เว็บไซต์ chicchiclawtutor.com • อัปเดตล่าสุด: 20 มกราคม 2569
            </p>

            <div className="card border">
              <div className="card-body p-4 p-md-5">
                <p className="mb-4">
                  เว็บไซต์ <strong>chicchiclawtutor.com</strong> (&quot;เว็บไซต์&quot;)
                  ให้ความสำคัญกับการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการ
                  เอกสารฉบับนี้อธิบายถึงการเก็บรวบรวม การใช้ การเปิดเผย
                  และการคุ้มครองข้อมูลส่วนบุคคลของคุณ
                  ตามกฎหมายคุ้มครองข้อมูลส่วนบุคคลของประเทศไทย (PDPA)
                </p>

                <hr />

                {/* 1 */}
                <section className="mb-4">
                  <h2 className="h5">1. ข้อมูลส่วนบุคคลที่เราเก็บรวบรวม</h2>
                  <p className="mb-2">เราอาจเก็บรวบรวมข้อมูลดังต่อไปนี้:</p>
                  <ul>
                    <li>ข้อมูลบัญชีผู้ใช้ เช่น ชื่อ อีเมล รูปโปรไฟล์</li>
                    <li>ข้อมูลการใช้งานเว็บไซต์ เช่น การเข้าชมบทความ การเรียนคอร์ส</li>
                    <li>ข้อมูลการชำระเงิน (โดยผ่านผู้ให้บริการชำระเงินภายนอก)</li>
                    <li>ข้อมูลทางเทคนิค เช่น IP Address, ประเภทอุปกรณ์, Browser</li>
                  </ul>
                </section>

                {/* 2 */}
                <section className="mb-4">
                  <h2 className="h5">2. วัตถุประสงค์ในการใช้ข้อมูล</h2>
                  <ul>
                    <li>เพื่อให้บริการและบริหารจัดการบัญชีผู้ใช้</li>
                    <li>เพื่อให้ผู้ใช้เข้าถึงคอร์สเรียนและเนื้อหาที่ซื้อ</li>
                    <li>เพื่อปรับปรุงคุณภาพเว็บไซต์และประสบการณ์ผู้ใช้</li>
                    <li>เพื่อความปลอดภัยของระบบและป้องกันการใช้งานที่ผิดกฎหมาย</li>
                  </ul>
                </section>

                {/* 3 */}
                <section className="mb-4">
                  <h2 className="h5">3. ข้อมูลเกี่ยวกับคอร์สและวิดีโอ</h2>
                  <ul>
                    <li>
                      การเข้าชมวิดีโอหรือคอร์สเรียนจะถูกบันทึกเพื่อควบคุมสิทธิ์การเข้าถึง
                    </li>
                    <li>
                      ห้ามนำข้อมูลการเข้าเรียนไปใช้เพื่อการตรวจสอบหรือประเมินบุคคลอื่น
                    </li>
                  </ul>
                </section>


                {/* 4 */}
                <section className="mb-4">
                  <h2 className="h5">4. การเปิดเผยข้อมูลแก่บุคคลภายนอก</h2>
                  <p className="mb-2">
                    เว็บไซต์จะไม่เปิดเผยข้อมูลส่วนบุคคลของผู้ใช้แก่บุคคลภายนอก
                    เว้นแต่ในกรณีดังต่อไปนี้:
                  </p>
                  <ul>
                    <li>ได้รับความยินยอมจากผู้ใช้</li>
                    <li>เป็นการปฏิบัติตามกฎหมายหรือคำสั่งศาล</li>
                    <li>
                      จำเป็นต่อการให้บริการ เช่น ระบบชำระเงิน
                      ระบบวิเคราะห์
                    </li>
                  </ul>
                </section>

                {/* 5 */}
                <section className="mb-4">
                  <h2 className="h5">5. การเก็บรักษาและความปลอดภัยของข้อมูล</h2>
                  <ul>
                    <li>
                      เว็บไซต์ใช้มาตรการด้านเทคนิคและการจัดการ
                      เพื่อรักษาความปลอดภัยของข้อมูล
                    </li>
                    <li>
                      ข้อมูลจะถูกจัดเก็บตามระยะเวลาที่จำเป็นต่อวัตถุประสงค์ในการให้บริการ
                    </li>
                  </ul>
                </section>

                {/* 8 */}
                <section className="mb-4">
                  <h2 className="h5">8. สิทธิของเจ้าของข้อมูลส่วนบุคคล</h2>
                  <p className="mb-2">คุณมีสิทธิตามกฎหมาย PDPA ได้แก่:</p>
                  <ul>
                    <li>ขอเข้าถึงหรือขอสำเนาข้อมูลของตน</li>
                    <li>ขอแก้ไขข้อมูลให้ถูกต้อง</li>
                    <li>ขอให้ลบหรือระงับการใช้ข้อมูล</li>
                    <li>ขอถอนความยินยอมในการใช้ข้อมูล</li>
                  </ul>
                </section>

                {/* 9 */}
                <section className="mb-4">
                  <h2 className="h5">9. คุกกี้ (Cookies)</h2>
                  <ul>
                    <li>
                      เว็บไซต์อาจใช้คุกกี้เพื่อจดจำการตั้งค่า
                      และปรับปรุงประสบการณ์การใช้งาน
                    </li>
                    <li>
                      ผู้ใช้สามารถตั้งค่า Browser
                      เพื่อปฏิเสธการใช้คุกกี้ได้
                    </li>
                  </ul>
                </section>

                {/* 10 */}
                <section className="mb-4">
                  <h2 className="h5">10. การแก้ไขนโยบายความเป็นส่วนตัว</h2>
                  <p>
                    เว็บไซต์อาจปรับปรุงนโยบายฉบับนี้เป็นครั้งคราว
                    โดยจะแจ้งผ่านหน้าเว็บไซต์และระบุวันที่อัปเดตล่าสุด
                  </p>
                </section>

                {/* 10 */}
                <section className="mb-2">
                  <h2 className="h5">10. ช่องทางการติดต่อ</h2>
                  <p className="mb-2">
                    หากมีคำถามหรือประสงค์ใช้สิทธิเกี่ยวกับข้อมูลส่วนบุคคล
                    สามารถติดต่อได้ที่:
                  </p>
                  <ul className="mb-0">
                    <li>Email: chicchiclawtutor@gmail.com</li>
                    <li>facebook: พิชิตเนติฯ อัยการ ผู้พิพากษาแบบ chic chic</li>
                  </ul>
                </section>

                <p className="text-muted small mb-0">
                  การใช้งานเว็บไซต์ต่อไป ถือว่าคุณยอมรับนโยบายความเป็นส่วนตัวฉบับนี้
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

